import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';
import {getFormData} from 'utilities/helper/formDataConvertor';
interface IResponse {
  guid: string;
  name: string;
  account_type: string;
  username: string;
  phone_number: string;
  state: number;
  city: number;
  profile_image: string | null;
  role: string;
}

export const updateProfile = async (payload: IUpdateProfilePayload) => {
  const {data}: {data: IResponse} = await request.put(
    `/api/profile/market-profile`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
  return data;
};
export const getProfile = async (ctx: QueryFunctionContext) => {
  const params = ctx.queryKey[1];
  const {data}: {data: IProfile} = await request.get(
    `/api/profile/supplier-profile?guid=` + params,
  );
  return data;
};
